import {App} from '../components/app/app'

export default App
